export const getValidBox = (targetValue: string) => {
  const splitBox = targetValue.split(" ");
  return splitBox[0]?.toUpperCase() === "2A" && splitBox[1].length === 4;
};
